// Unpublished Work © 2025 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {ListItem, ListItemText, Skeleton} from '@deere/isg.component-library';

function JobListItem(props) {
    const {
        job,
        loading,
        secondaryAction,
        translations
    } = props;

    return (
        <ListItem
            secondaryAction={loading ? null : secondaryAction}
        >
            <ListItemText
                primary={loading ? <Skeleton
                    animation='pulse'
                    variant='text'
                    width='85%'
                /> : job.title}
                secondary={`${translations.ONLINK_OPERATOR_COUNT}: ${loading ? '---' : job.operatorCount || '---'}`}
                slotProps={{
                    primary: {
                        sx: {
                            color: 'text.primary'
                        }
                    }
                }}
            />
        </ListItem>
    );
}

JobListItem.propTypes = {
    job: PropTypes.object,
    loading: PropTypes.bool,
    secondaryAction: PropTypes.object,
    translations: PropTypes.translations
};

export default JobListItem;
